import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TruckJourneyDelivery, TruckJourneyInfo } from '../../models/truck-journey.model';

@Component({
  selector: 'app-truck-journey-info',
  templateUrl: './truck-journey-info.component.html',
  styleUrls: ['./truck-journey-info.component.scss']
})
export class TruckJourneyInfoComponent implements OnChanges {

  @Input() public truckJourney: TruckJourneyInfo;
  @Input() public readOnly = false;

  @Output() public onEditClick: EventEmitter<boolean> = new EventEmitter();

  public truckJourneyOpened = false
  public loadIds: string;
  public uniqueDeliveries: TruckJourneyDelivery[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    this.loadIds = this.truckJourney.loads.map(load => `#${load.loadId}`).join(' ; ');

    const seen = new Set<string>();
    this.uniqueDeliveries = this.truckJourney.loads
      .flatMap(load => load.stops.flatMap(stop => stop.deliveries))
      .filter(d => {
        if (seen.has(d.number)) return false;
        seen.add(d.number);
        return true;
      });
  }

  public editTruckjourney(assignLoads: boolean): void {
    this.onEditClick.emit(assignLoads);
  }

  public openOrCloseTruckJourney(): void {
    this.truckJourneyOpened = !this.truckJourneyOpened;
  }
}
